export default "__VITE_ASSET__41f06e30__"